document.addEventListener("DOMContentLoaded", () => {
  const addToCartForms = document.querySelectorAll("form[action='/cart/add']");

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      if (this.classList.contains("submitting")) return;
      this.classList.add("submitting");

      // Show loading state
      const buttonLoading = this.querySelector(".button-loading");
      const buttonContent = this.querySelector(".product-page-button-content");
      if (buttonLoading && buttonContent) {
        buttonLoading.style.display = "flex";
        buttonContent.style.display = "none";
      }

      try {
        // First add item to cart

        const variantInput = this.querySelector('input[name="id"]');
        const selectedVariantId = variantInput ? variantInput.value : null;

        // Create form data
        const formData = new FormData(this);

        // Only add variant image if variants exist and are defined
        if (
          selectedVariantId &&
          window.variants &&
          window.variants[selectedVariantId]
        ) {
          const variant = window.variants[selectedVariantId];
          if (variant.images && variant.images.length > 0) {
            formData.append("properties[_variant_image]", variant.images[0]);
          }
        }

        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: new FormData(this),
        });
        const data = await response.json();
        console.log("Item added successfully:", data);

        // Then update all cart data before showing anything
        await Promise.all([
          updateCartItems(),
          updateCartCount(),
          updateCartTotal(),
        ]);

        // Get DOM elements first
        const modal = document.getElementById("menu");
        const menuBtn = document.getElementById("menu-toggle");
        const bodyblock = document.getElementById("body-block");
        const menuSections = document.querySelectorAll(".menu-section-wrapper");
        const cartWrapper = document.getElementById("cart-container-wrapper");
        const cartContainer = document.querySelector(".cart-container");
        const returnToMenuBtn = document.getElementById("return-to-menu");

        const menuSVG = document.querySelector(".CL_MENU");
        const closeSVG = document.querySelector(".menu-close");

        // Add 500ms delay before showing cart
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Use the SAME animation sequence as your menu toggle
        // First hide both container and contents to start fresh
        if (typeof window.hideMenuContainer === "function") {
          window.hideMenuContainer();
        }
        if (typeof window.hideMenuContents === "function") {
          window.hideMenuContents();
        }

        // Make menu visible but with opacity 0 (already set by hideMenuContainer)
        modal.style.display = "block";
        menuBtn.classList.add("toggled");
        document.body.style.overflow = "hidden";
        bodyblock.style.display = "block";

        // Update SVG icons
        if (menuSVG && closeSVG) {
          menuSVG.style.display = "none";
          closeSVG.style.display = "block";
          menuBtn.classList.remove("toggled");
        }

        // Hide menu sections - this prepares for showing cart
        menuSections.forEach((section) => {
          section.style.display = "none";
        });

        // ADD THIS CODE: Hide menu gradient when showing cart
        const menuGradient = document.querySelector(".menu-gradient");
        if (menuGradient) {
          menuGradient.style.display = "none"; // Completely hide it, not just opacity
        }

        // Set up cart with initial opacity 0
        cartWrapper.style.opacity = "0";
        cartWrapper.style.display = "flex";
        cartWrapper.style.transition = "opacity 0.5s ease-out";
        cartContainer.style.display = "none";
        returnToMenuBtn.style.display = "flex";

        // Reset cart scroll position
        const dynamicCartItems = document.getElementById("dynamic-cart-items");
        if (dynamicCartItems) {
          dynamicCartItems.scrollTop = 0;
        }

        // First fade in just the menu container (and its gradient)
        if (typeof window.fadeInMenuContainer === "function") {
          setTimeout(function () {
            window.fadeInMenuContainer();
          }, 10);
        }

        // Then fade in the menu content wrapper and cart
        setTimeout(function () {
          // THIS IS THE FIX - also set menu-content-wrapper opacity to 1
          const menuContentWrapper = document.querySelector(
            ".menu-content-wrapper"
          );
          if (menuContentWrapper) {
            menuContentWrapper.style.opacity = "1";
          }

          // Continue with showing the cart
          cartWrapper.style.opacity = "1";

          // Initialize cart gradient
          if (typeof window.initializeCartGradient === "function") {
            window.initializeCartGradient();
          }
        }, 50);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        if (buttonLoading && buttonContent) {
          buttonLoading.style.display = "none";
          buttonContent.style.display = "flex";
        }
        this.classList.remove("submitting");
      }
    });
  });

  initializeRemoveButtons();
});

// Function to update just the cart items
function updateCartItems() {
  // Get the latest cart data
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      console.log("Current cart:", cart);
      const cartContainer = document.getElementById("dynamic-cart-items");
      if (!cartContainer) {
        console.error("Cart container not found!");
        return;
      }

      // Clear current cart items
      cartContainer.innerHTML = "";

      // Add all items from the updated cart
      if (cart.items && cart.items.length > 0) {
        cart.items.forEach((item) => {
          console.log("Adding item to cart display:", item);
          // For each quantity, add a separate cart item
          for (let i = 0; i < item.quantity; i++) {
            // Create item element
            const cartItem = document.createElement("div");
            cartItem.className = "cart-item";
            // Ensure visibility
            cartItem.style.display = "flex";
            cartItem.style.visibility = "visible";
            cartItem.style.opacity = "1";

            // Set data attributes
            cartItem.dataset.soldOutType1 = "false";
            cartItem.dataset.soldOutType2 = "false";
            cartItem.dataset.variantId = item.variant_id;
            cartItem.dataset.itemKey = item.key;

            // Image URL
            let imageSrc = "";
            if (item.properties && item.properties._variant_image) {
              // Use variant image if it was specifically selected
              imageSrc = item.properties._variant_image;
            } else if (item.image) {
              // Fallback to default product image
              imageSrc = item.image;
            }

            // Add _70x suffix for cart thumbnail if needed
            if (imageSrc && !imageSrc.includes("_70x")) {
              imageSrc = imageSrc.replace(
                /\.(jpg|jpeg|png|gif|webp)/i,
                "_70x.$1"
              );
            }

            // Create the cart item HTML
            // Inside updateCartItems function, after creating cartItem.innerHTML but before cartContainer.appendChild(cartItem)
            cartItem.innerHTML = `
              <img src="${imageSrc}" alt="${item.title}" loading="eager">
              <div class="sku-price">
                <p>${item.sku || ""}</p>
                <p>${formatLocalizedPrice(item.price)}</p>
              </div>
              <form class="remove-button">
                <input type="hidden" name="id" value="${item.key}">
                <input type="hidden" name="quantity" value="${
                  item.quantity - 1
                }">
                <button type="submit">REMOVE</button>
              </form>
            `;

            const removeForm = cartItem.querySelector(".remove-button");
            removeForm.addEventListener("submit", async function (event) {
              event.preventDefault();

              if (this.classList.contains("submitting")) return;
              this.classList.add("submitting");

              //removal animation
              this.classList.add("clicked");
              const cartItem = this.closest(".cart-item");

              // Add classes to trigger transitions
              const skuPrice = cartItem.querySelector(".sku-price");
              const imgElement = cartItem.querySelector("img");

              if (skuPrice) {
                skuPrice.classList.add("fading-out");
              }
              if (imgElement) {
                imgElement.classList.add("fading-out");
              }

              try {
                const response = await fetch("/cart/change.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: this.querySelector('input[name="id"]').value,
                    quantity: parseInt(
                      this.querySelector('input[name="quantity"]').value
                    ),
                  }),
                });

                const data = await response.json();

                // Update all cart data
                await Promise.all([
                  updateCartItems(),
                  updateCartCount(),
                  updateCartTotal(),
                ]);
              } catch (error) {
                console.error("Error removing item:", error);
              } finally {
                this.classList.remove("submitting");
              }
            });

            cartContainer.appendChild(cartItem);
          }
        });
      } else {
        console.log("Cart is empty");
        // Maybe add an empty cart message
      }

      // Make the container visible
      cartContainer.style.visibility = "visible";

      // Update the cart total
      const totalPriceElement = document.getElementById("cart-total-price");
      if (totalPriceElement) {
        totalPriceElement.textContent = formatMoney(cart.total_price);
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);
    });
}

// price formatting
function formatLocalizedPrice(cents) {
  // Get market from request.market.id like in cart.liquid
  const market = document.documentElement.getAttribute("data-market") || "US";

  if (market === "JP") {
    // Japanese format: ¥1000
    return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
  } else {
    // US format: $10
    return (
      "$" +
      (cents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    );
  }
}

// market id
function formatLocalizedPrice(cents) {
  // Use the same market context as Shopify
  const market = Shopify.currency.active;

  if (market === "JPY") {
    // Japanese format: ¥1000
    return "¥" + Math.round(cents / 100).toLocaleString("ja-JP");
  } else {
    // US format: $10
    return (
      "$" +
      (cents / 100).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    );
  }
}

// cart total
function updateCartTotal() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Update total price display
      const totalPriceElement = document.getElementById("cart-total-price");
      if (totalPriceElement) {
        totalPriceElement.textContent = formatLocalizedPrice(cart.total_price);
      }

      // Update checkout button data attribute
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.setAttribute(
          "data-formatted-price",
          formatLocalizedPrice(cart.total_price)
        );
      }
    })
    .catch((error) => {
      console.error("Error updating cart total:", error);
    });
}

// cart count
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountContainer = document.querySelector(
        ".cart-count-container"
      );
      if (cartCountContainer) {
        cartCountContainer.textContent = cart.item_count;
      }
    })
    .catch((error) => {
      console.error("Error updating cart count:", error);
    });
}

//remove
function initializeRemoveButtons() {
  const existingRemoveButtons = document.querySelectorAll(".remove-button");

  existingRemoveButtons.forEach((removeForm) => {
    removeForm.addEventListener("submit", async function (event) {
      event.preventDefault();

      if (this.classList.contains("submitting")) return;
      this.classList.add("submitting");

      //removal animation
      this.classList.add("clicked");
      const cartItem = this.closest(".cart-item");

      // Target the sku-price and img elements
      // Add classes to trigger transitions
      // Add classes to trigger transitions
      const skuPrice = cartItem.querySelector(".sku-price");
      const imgElement = cartItem.querySelector("img");

      if (skuPrice) {
        skuPrice.classList.add("fading-out");
      }
      if (imgElement) {
        imgElement.classList.add("fading-out");
      }

      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: this.querySelector('input[name="id"]').value,
            quantity: parseInt(
              this.querySelector('input[name="quantity"]').value
            ),
          }),
        });

        const data = await response.json();

        // Update all cart data
        await Promise.all([
          updateCartItems(),
          updateCartCount(),
          updateCartTotal(),
        ]);
      } catch (error) {
        console.error("Error removing item:", error);
      } finally {
        this.classList.remove("submitting");
      }
    });
  });
}
